<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data || {});
const buttons = computed(() => data.value.buttons || []);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="evolution-button">
    <div class="flex flex-col gap-2">
      <p v-if="data.title" class="font-medium mb-0">{{ data.title }}</p>
      <p v-if="data.description" class="mb-0">{{ data.description }}</p>
      <p v-if="data.footer" class="text-xs opacity-70 mb-0">
        {{ data.footer }}
      </p>
      <div class="flex flex-col gap-1.5 mt-1">
        <div
          v-for="(button, index) in buttons"
          :key="index"
          class="px-3 py-1.5 rounded-lg bg-n-alpha-1 text-center text-sm font-medium"
        >
          {{ button.displayText || button.name }}
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
